import { ArrowUpRight } from 'lucide-react';
import { PERSONAL, IMAGES } from '../../mock';

export default function Personal() {
  return (
    <section id="personal" className="py-20 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6">
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#0B3B2E]/70 font-medium reveal">
              {PERSONAL.eyebrow}
            </p>
            <h2 className="mt-4 font-serif text-[40px] lg:text-[56px] leading-[1.05] text-[#0B3B2E] reveal">
              {PERSONAL.title}
            </h2>
            <p className="mt-6 text-[17px] leading-relaxed text-[#0E1F1A]/70 max-w-[520px] reveal">
              {PERSONAL.body}
            </p>
          </div>
          <div className="lg:col-span-6 reveal">
            <div className="relative aspect-[5/4] rounded-[24px] overflow-hidden shadow-[0_30px_80px_-30px_rgba(11,59,46,0.35)]">
              <img src={IMAGES.personal} alt="Travel abroad" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-4">
          {PERSONAL.cards.map((c, i) => (
            <div
              key={c.title}
              className="group reveal p-7 rounded-2xl bg-[#EFE9D8] border border-[#0B3B2E]/10 hover:bg-[#F5F1E8] hover:border-[#0B3B2E]/30 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-baseline gap-3">
                <span className="font-serif text-[36px] text-[#C8944B] leading-none">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span className="h-px flex-1 bg-[#0B3B2E]/15" />
              </div>
              <h3 className="mt-5 font-serif text-[24px] text-[#0B3B2E]">{c.title}</h3>
              <p className="mt-2 text-[14px] leading-relaxed text-[#0E1F1A]/65">{c.description}</p>
              <span className="mt-6 inline-flex items-center gap-1 text-[13px] font-medium text-[#0B3B2E]">
                Learn more
                <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
